export default "__VITE_ASSET__a313318f__"